<template>
  <div>
    <div :id="qrCodeId" class="text-center"></div>
    <v-btn
      v-if="showDownloadButton"
      class="mb-2"
      text
      outlined
      @click="downloadQRCode"
      min-width="200"
      >Download QR Code</v-btn
    >
  </div>
</template>

<script>
import QRCodeStyling from "qr-code-styling";

let uuid = require("uuid");

export default {
  props: {
    link: { type: String },
    logo: { type: String, default: "" },
    showDownloadButton: { type: Boolean, default: true },
    size: { type: Number, default: 180 },
  },

  watch: {
    logo: function (newValue) {
      this.options.image = newValue;
      this.qrCode.update(this.options);
    },
  },

  mounted() {
    this.initQRCode();
  },
  created() {
    this.image =
      this.logo == "" ? require("@/assets/logo-large.png") : this.logo;
    this.options = {
      width: this.size,
      height: this.size,
      type: "canvas",
      data: encodeURI(this.link),
      image: this.image,
      dotsOptions: {
        color: "#002434",
        type: "rounded",
      },
      imageOptions: {
        crossOrigin: "anonymous",
        margin: 5,
        imageSize: 0.3,
      },
      qrOptions: {
        typeNumber: 6,
      },
    };

    //Set unique id
    this.qrCodeId = "canvas" + uuid.v1();
  },
  data() {
    return {
      qrCode: {},
      options: {},
      qrCodeId: "",
    };
  },
  methods: {
    downloadQRCode() {
      this.qrCode.download({ name: "qr", extension: "png" });
    },
    initQRCode() {
      this.qrCode = new QRCodeStyling(this.options);
      this.qrCode.append(document.getElementById(this.qrCodeId));
    },
  },
};
</script>

<style></style>
